export const squirrelUrl = () => {
  if (typeof window === 'undefined') {
    return process.env.SQUIRREL_WIDGET_SCRIPT || ''
  }

  return window.squirrelURL || ''
}
